<template>
  <div class="dashboard">
    <vue-element-loading :active="visible" :is-full-screen="true" />

    <b-card>

      <b-row class="py-3 px-1" v-if="userType === '2'">
        <b-col cols="12" class="text-right">
          <b-button variant="primary" to="/report-crime">Report Crime</b-button>
        </b-col>
      </b-row>

      <b-row class="py-3 px-1 ">
        <b-col cols="12">
        <Dashboard-table />
        </b-col>

         <b-col cols="12" class="pt-3">
        <UserMap/>
        </b-col>
       <b-col cols="12" class="pt-3">
        <CrimeLocations/>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import store from '../../store'
import VueElementLoading from 'vue-element-loading'
import DashboardTable from './DashboardTable'
import UserMap from './userMap'
import CrimeLocations from './crimeLocations'

export default {
  name: 'dashboard',
  components: {
    DashboardTable,
    VueElementLoading,
    UserMap,
    CrimeLocations,
  },
  data () {
    return {
      visible: false,
      msg: '',
      userType: localStorage.getItem('userType'),
    }
  },
  // mounted: function () {
  //   this.getList()
  // },
  mounted: function () {
    this.logout()
  },
  methods: {
    launchEpicmaxToast () {
      this.showToast(`Let's work together!`, {
        icon: 'fa-star-o',
        position: 'top-right',
        duration: Infinity,
        action: {
          text: 'Hire us',
          href: 'http://epicmax.co/#/contact',
          class: 'vuestic-toasted-link',
        },
      })
    },
    getList () {
      this.visible = true
      axios({
        method: 'POST',
        url: '/admin/analytics',
        headers: {
          token: localStorage.getItem('token'),
        },
        data: { type: 'pending' },
      })
        .then(response => {
          // console.log(response.data.data)
          if (response.data.status === true) {
            this.data = response.data.data
            this.visible = false
          } else if (response.data.status === false) {
            this.visible = false
            this.msg = 'No Data Found!!'
          }
        })
        .catch(e => {
          console.log(e)
          this.visible = false
          this.errors.push(e)
          this.msg = 'failed'
        })
    },
    logout () {
      axios({
        method: 'POST',
        url: '/authenticate/',
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then(response => {
          if (response.data.expired === true) {
            localStorage.removeItem('token')
            // localStorage.removeItem('email')
            store.commit('logoutUser')
            this.$router.push({ name: 'login' })
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>

<style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0 !important;
  }
}
</style>
